/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_road__distribution_routes = /** @type {(inputs: {}) => string} */ () => {
	return `Verteilung der Straßen`
};

const en_road__distribution_routes = /** @type {(inputs: {}) => string} */ () => {
	return `Road layout`
};

const es_road__distribution_routes = /** @type {(inputs: {}) => string} */ () => {
	return `Distribución de las carreteras`
};

const fr_road__distribution_routes = /** @type {(inputs: {}) => string} */ () => {
	return `Répartition des routes`
};

const it_road__distribution_routes = /** @type {(inputs: {}) => string} */ () => {
	return `Distribuzione delle strade`
};

const nl_road__distribution_routes = /** @type {(inputs: {}) => string} */ () => {
	return `Verdeling van wegen`
};

const pt_road__distribution_routes = /** @type {(inputs: {}) => string} */ () => {
	return `Distribuição das estradas`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const road__distribution_routes = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.road__distribution_routes(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("road__distribution_routes", locale)
	if (locale === "de") return de_road__distribution_routes(inputs)
	if (locale === "en") return en_road__distribution_routes(inputs)
	if (locale === "es") return es_road__distribution_routes(inputs)
	if (locale === "fr") return fr_road__distribution_routes(inputs)
	if (locale === "it") return it_road__distribution_routes(inputs)
	if (locale === "nl") return nl_road__distribution_routes(inputs)
	return pt_road__distribution_routes(inputs)
};